import axios from "axios";
import { useEffect, useState } from "react";
import Select from "react-select";
import useStore from "../../store/useStore";
import { customStyleSelectCards } from "../../styles/styleSelect";
import { SelectProps } from "./cardsTypes";

export function InputCenterCost() {
  const [costCenterOpt, setCostCenterOpt] = useState<SelectProps[]>([]);
  const { setCenterCost, centerCost } = useStore((state) => state);

  useEffect(() => {
    (async function fetchData() {
      try {
        const { data } = await axios.get(
          "https://radar.tlpservicos.com.br/api/company/cost-centers"
        );
        setCostCenterOpt(
          data.map((item: { centro_custo: string; descricao: string }) => ({
            value: item.centro_custo,
            label: `${item.centro_custo}${item.descricao && "\n"}${item.descricao}`,
          }))
        );
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  return (
    <div className=" bg-gray-50 dark:bg-gray-350 rounded-lg h-full flex flex-col overflow-visible">
      <div className=" bg-gray-100 dark:bg-gray-400 h-6 drag-handle cursor-move flex items-center px-2 rounded-t-md font-semibold text-sm">
        Centro de Custo
      </div>
      <div className="flex-grow flex flex-col justify-center px-1">
        <Select
          options={costCenterOpt}
          styles={customStyleSelectCards<SelectProps>()}
          placeholder="centro de custo"
          isClearable
          isSearchable
          className="rounded-lg w-full text-sm"
          classNamePrefix="select"
          noOptionsMessage={() => "Nenhum centro de custo encontrado"}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          defaultValue={centerCost}
          onChange={setCenterCost}
        />
      </div>
    </div>
  );
}
